var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _path, _path2, _path3, _path4, _g9, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDesktopSm(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 494,
    height: 476,
    viewBox: "0 0 494 476",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M178.858 109.745L145.841 128.782L67.9102 83.5698L102.117 64.5332L178.858 109.745Z",
    stroke: "white",
    strokeWidth: 1.45886,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.858 210.281L145.841 229.318L67.9102 184.106L102.117 165.069L178.858 210.281Z",
    stroke: "white",
    strokeWidth: 1.45886,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.671 210.281L145.655 229.318L67.7236 184.106L101.93 165.069L178.671 210.281Z",
    stroke: "white",
    strokeWidth: 1.45886,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.842 128.782V229.319",
    stroke: "white",
    strokeWidth: 1.45886,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.415 64.5332V165.07L67.9443 184.074V83.5368",
    stroke: "white",
    strokeWidth: 1.45886,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.86 109.415V209.952",
    stroke: "white",
    strokeWidth: 1.45886,
    strokeMiterlimit: 10
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M113.134 146.894L80.1177 165.93L2.18652 120.718L36.3929 101.682L113.134 146.894Z",
    stroke: "white",
    strokeWidth: 1.45884,
    strokeMiterlimit: 10,
    strokeDasharray: "4.83 4.83"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.134 247.431L80.1177 266.467L2.18652 221.255L36.3929 202.219L113.134 247.431Z",
    stroke: "#231F20",
    strokeWidth: 1.45884,
    strokeMiterlimit: 10,
    strokeDasharray: "4.83 4.83"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.948 247.431L79.9312 266.467L2 221.255L36.2064 202.219L112.948 247.431Z",
    stroke: "white",
    strokeWidth: 1.45884,
    strokeMiterlimit: 10,
    strokeDasharray: "4.83 4.83"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.1182 165.931V266.468",
    stroke: "white",
    strokeWidth: 1.45884,
    strokeMiterlimit: 10,
    strokeDasharray: "4.83 4.83"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.6915 101.682V202.219L2.2207 221.222V120.685",
    stroke: "white",
    strokeWidth: 1.45884,
    strokeMiterlimit: 10,
    strokeDasharray: "4.83 4.83"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.137 146.563V247.101",
    stroke: "white",
    strokeWidth: 1.45884,
    strokeMiterlimit: 10,
    strokeDasharray: "4.83 4.83"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M389.368 160.014L356.351 179.05L278.42 133.838L312.626 114.802L389.368 160.014Z",
    stroke: "white",
    strokeWidth: 1.45886,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.368 260.551L356.351 279.587L278.42 234.375L312.626 215.339L389.368 260.551Z",
    stroke: "white",
    strokeWidth: 1.45886,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.181 260.551L356.165 279.587L278.233 234.375L312.44 215.339L389.181 260.551Z",
    stroke: "white",
    strokeWidth: 1.45886,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.352 179.051V279.588",
    stroke: "white",
    strokeWidth: 1.45886,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.924 114.802V215.339L278.453 234.343V133.805",
    stroke: "white",
    strokeWidth: 1.45886,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.37 159.684V260.221",
    stroke: "white",
    strokeWidth: 1.45886,
    strokeMiterlimit: 10
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M491.677 216.738L458.661 235.775L380.729 190.563L414.936 171.526L491.677 216.738Z",
    stroke: "white",
    strokeWidth: 1.45884,
    strokeMiterlimit: 10,
    strokeDasharray: "4.83 4.83"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M491.677 317.275L458.661 336.312L380.729 291.1L414.936 272.063L491.677 317.275Z",
    stroke: "#231F20",
    strokeWidth: 1.45884,
    strokeMiterlimit: 10,
    strokeDasharray: "4.83 4.83"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M491.491 317.275L458.474 336.312L380.543 291.1L414.749 272.063L491.491 317.275Z",
    stroke: "white",
    strokeWidth: 1.45884,
    strokeMiterlimit: 10,
    strokeDasharray: "4.83 4.83"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M458.661 235.775V336.313",
    stroke: "white",
    strokeWidth: 1.45884,
    strokeMiterlimit: 10,
    strokeDasharray: "4.83 4.83"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.234 171.526V272.064L380.764 291.067V190.53",
    stroke: "white",
    strokeWidth: 1.45884,
    strokeMiterlimit: 10,
    strokeDasharray: "4.83 4.83"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M491.68 216.408V316.945",
    stroke: "white",
    strokeWidth: 1.45884,
    strokeMiterlimit: 10,
    strokeDasharray: "4.83 4.83"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M205.704 92.0176L238.721 111.054L316.652 65.8423L282.445 46.8057L205.704 92.0176Z",
    stroke: "white",
    strokeWidth: 1.45886,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.704 192.555L238.721 211.591L316.652 166.379L282.445 147.343L205.704 192.555Z",
    stroke: "white",
    strokeWidth: 1.45886,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.891 192.555L238.907 211.591L316.838 166.379L282.632 147.343L205.891 192.555Z",
    stroke: "white",
    strokeWidth: 1.45886,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.721 111.055V211.592",
    stroke: "white",
    strokeWidth: 1.45886,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.148 46.8057V147.343L316.619 166.346V65.8092",
    stroke: "white",
    strokeWidth: 1.45886,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.704 91.6875V192.225",
    stroke: "white",
    strokeWidth: 1.45886,
    strokeMiterlimit: 10
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M133.043 46.7198L166.06 65.7564L243.991 20.5444L209.784 1.50781L133.043 46.7198Z",
    stroke: "white",
    strokeWidth: 1.45884,
    strokeMiterlimit: 10,
    strokeDasharray: "4.83 4.83"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.043 147.257L166.06 166.294L243.991 121.082L209.784 102.045L133.043 147.257Z",
    stroke: "#231F20",
    strokeWidth: 1.45884,
    strokeMiterlimit: 10,
    strokeDasharray: "4.83 4.83"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.229 147.257L166.246 166.294L244.177 121.082L209.971 102.045L133.229 147.257Z",
    stroke: "white",
    strokeWidth: 1.45884,
    strokeMiterlimit: 10,
    strokeDasharray: "4.83 4.83"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.06 65.7568V166.294",
    stroke: "white",
    strokeWidth: 1.45884,
    strokeMiterlimit: 10,
    strokeDasharray: "4.83 4.83"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.487 1.50781V102.045L243.958 121.049V20.5114",
    stroke: "white",
    strokeWidth: 1.45884,
    strokeMiterlimit: 10,
    strokeDasharray: "4.83 4.83"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.043 46.3896V146.927",
    stroke: "white",
    strokeWidth: 1.45884,
    strokeMiterlimit: 10,
    strokeDasharray: "4.83 4.83"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M210.662 355.527L243.679 374.564L321.61 329.352L287.404 310.315L210.662 355.527Z",
    stroke: "white",
    strokeWidth: 1.45884,
    strokeMiterlimit: 10,
    strokeDasharray: "4.83 4.83"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.662 456.065L243.679 475.101L321.61 429.889L287.404 410.853L210.662 456.065Z",
    stroke: "#231F20",
    strokeWidth: 1.45884,
    strokeMiterlimit: 10,
    strokeDasharray: "4.83 4.83"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.85 456.065L243.866 475.101L321.797 429.889L287.591 410.853L210.85 456.065Z",
    stroke: "white",
    strokeWidth: 1.45884,
    strokeMiterlimit: 10,
    strokeDasharray: "4.83 4.83"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.679 374.564V475.102",
    stroke: "white",
    strokeWidth: 1.45884,
    strokeMiterlimit: 10,
    strokeDasharray: "4.83 4.83"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.106 310.315V410.853L321.577 429.856V329.319",
    stroke: "white",
    strokeWidth: 1.45884,
    strokeMiterlimit: 10,
    strokeDasharray: "4.83 4.83"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.662 355.197V455.734",
    stroke: "white",
    strokeWidth: 1.45884,
    strokeMiterlimit: 10,
    strokeDasharray: "4.83 4.83"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M145.842 310.435L178.858 329.471L256.79 284.259L222.583 265.223L145.842 310.435Z",
    stroke: "white",
    strokeWidth: 1.45886,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.842 410.971L178.858 430.007L256.79 384.795L222.583 365.759L145.842 410.971Z",
    stroke: "white",
    strokeWidth: 1.45886,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.029 410.971L179.046 430.007L256.977 384.795L222.771 365.759L146.029 410.971Z",
    stroke: "white",
    strokeWidth: 1.45886,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.858 329.472V430.009",
    stroke: "white",
    strokeWidth: 1.45886,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.286 265.223V365.76L256.757 384.763V284.226",
    stroke: "white",
    strokeWidth: 1.45886,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.842 310.104V410.642",
    stroke: "white",
    strokeWidth: 1.45886,
    strokeMiterlimit: 10
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M193.671 229.401C185.907 232.997 183.666 232.083 175.546 234.959C171.319 236.457 164.681 238.808 158.146 244.143C152.787 248.517 147.087 253.17 146.545 260.577C146.071 267.058 149.731 273.148 154.037 276.527C158.016 279.649 161.236 279.427 171.196 281.602C171.196 281.602 179.94 283.511 189.563 286.677C205.371 291.878 205.688 296.806 222.43 303.111C231.226 306.423 237.049 308.53 244.664 307.219C246.444 306.912 256.199 305.233 262.064 297.311C262.921 296.153 263.936 293.865 265.931 289.335C270.425 279.133 272.671 274.032 272.456 271.452C271.936 265.219 266.835 261.001 259.889 255.26C255.848 251.919 252.039 249.891 244.422 245.835C237.484 242.14 233.947 240.287 230.647 240.034C229.266 239.929 226.08 239.846 221.947 238.584C221.947 238.584 219.924 237.967 218.08 237.134C209.684 233.344 208.033 226.264 202.613 225.534C200.141 225.201 199.766 226.578 193.671 229.401Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M364.359 338.394C360.256 342.198 356.272 341.368 350.342 343.227C347.024 344.268 338.139 347.054 336.325 353.619C335.038 358.277 337.518 364.084 341.884 366.911C347.227 370.371 354.341 368.686 358.317 365.461C364.159 360.723 361.962 353.683 367.984 350.477C371.085 348.826 372.137 350.443 376.684 348.786C381.978 346.856 388.209 341.873 387.318 337.669C386.562 334.107 380.988 332.492 378.376 332.111C373.317 331.372 369.361 333.797 367.984 334.769C366.069 336.121 365.959 336.911 364.359 338.394Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M333.184 303.111C331.593 306.985 336.719 309.654 337.05 316.645C337.209 319.978 336.107 320.71 331.734 330.662C328.226 338.644 325.934 343.926 324.483 350.479C323.473 355.043 322.59 359.031 323.033 364.012C323.695 371.452 327.71 385.545 338.5 388.663C348.546 391.565 358.598 383.261 360.251 381.896C364.007 378.793 367.576 374.159 369.434 371.746C374.26 365.479 374.139 363.865 377.168 362.079C380.666 360.017 384.408 360.061 391.668 360.146C398.717 360.228 399.529 361.227 401.818 360.146C406.691 357.844 409.373 350.311 408.102 344.195C406.639 337.162 400.238 333.415 395.535 330.662C389.157 326.929 382.085 325.146 371.368 322.445C365.519 320.971 363.014 320.617 360.734 318.095C357.267 314.259 359.16 310.759 355.417 305.528C354.68 304.497 351.242 299.692 345.267 298.761C340.864 298.075 334.695 299.433 333.184 303.111Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M353.846 324.861C350.827 326.044 351.194 328.242 345.992 333.078C342.114 336.682 341.373 335.96 338.137 339.12C336.026 341.181 332.309 344.809 330.887 350.599C329.622 355.75 330.818 359.984 331.854 363.649C332.913 367.397 333.73 370.291 336.445 372.712C339.98 375.864 344.351 376.034 345.871 376.095C355.017 376.466 361.563 369.401 362.062 368.845C366.507 363.902 365.277 360.493 370.038 357.245C370.764 356.75 371.115 356.609 378.738 354.224C388.28 351.239 390.204 350.686 392.151 348.545C392.841 347.786 395.019 345.318 395.172 341.657C395.344 337.518 392.812 334.62 392.03 333.803C390.286 331.982 388.205 331.067 384.054 330.057C375.351 327.939 373.755 329.345 366.654 327.761C358.774 326.004 357.304 323.506 353.846 324.861Z",
    fill: "white"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M446.799 355.276L341.872 415.774L94.2061 272.09L202.914 211.592L446.799 355.276Z",
    fill: "white"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M181.65 239.497C173.747 241.751 169.718 242.917 165.941 244.814C159.621 247.99 156.205 249.706 154.825 253.514C152.869 258.91 156.222 265.132 159.658 268.498C164.794 273.528 171.686 273.715 175.366 273.815C188.122 274.161 190.996 267.068 200.984 268.74C207.068 269.758 205.773 272.352 215.967 275.99C222.442 278.3 231.051 281.24 238.684 277.44C240.095 276.738 243.809 274.823 245.693 270.673C248.908 263.591 243.937 256.286 243.518 255.689C240.716 251.705 236.881 250.06 235.301 249.406C229.679 247.079 227.244 248.98 215.967 247.714C211.393 247.201 209.105 246.944 207.025 246.023C200.42 243.096 200.338 238.475 195.184 236.839C194.185 236.522 192.905 236.288 181.65 239.497Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M189.387 247.406C181.499 245.06 174.467 248.894 173.678 249.339C171.45 250.598 168.969 252 168.603 254.414C168.082 257.859 172.146 261.52 175.853 262.873C180.244 264.475 184.553 262.994 188.42 261.664C194.889 259.441 195.552 257.089 199.779 257.073C202.201 257.063 204.374 258.073 208.72 260.093C215.31 263.157 216.888 265.366 220.2 264.806C222.183 264.471 224.595 263.175 224.912 261.302C225.223 259.463 223.392 257.791 222.737 257.193C221.095 255.695 219.296 255.107 211.862 253.931C206.565 253.093 205.895 253.141 203.283 252.481C200.775 251.847 198.801 251.147 197.12 250.548C191.864 248.671 191.743 248.106 189.387 247.406Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M360.381 350.011C359.338 349.716 358.558 349.495 357.701 349.252C359.309 346.631 360.869 344.09 362.492 341.446C361.663 341.237 360.977 341.065 360.177 340.864C361.679 338.069 363.151 335.331 364.689 332.469C363.753 332.332 362.98 332.218 361.933 332.064C365.263 327.361 367.196 322.105 369.202 316.565C371.294 322.042 373.117 327.35 376.543 332.062C375.496 332.212 374.698 332.325 373.742 332.461C375.275 335.297 376.743 338.014 378.277 340.852C377.52 341.044 376.841 341.215 375.941 341.443C377.559 344.071 379.133 346.63 380.753 349.262C379.868 349.507 379.086 349.725 378.063 350.009C380.111 352.927 382.078 355.73 384.234 358.802H371.34V368.945H367.142V358.875H354.162C356.336 355.776 358.305 352.969 360.381 350.011Z",
    fill: "white",
    stroke: "#754D29",
    strokeWidth: 2.91771,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M332.869 365.541C331.112 365.043 329.799 364.671 328.355 364.262C331.064 359.848 333.691 355.568 336.424 351.114C335.028 350.764 333.874 350.474 332.526 350.135C335.056 345.428 337.535 340.815 340.125 335.997C338.549 335.765 337.246 335.574 335.483 335.314C341.091 327.393 344.347 318.541 347.727 309.211C351.249 318.435 354.32 327.375 360.09 335.311C358.326 335.562 356.982 335.754 355.372 335.983C357.953 340.759 360.427 345.335 363.011 350.115C361.735 350.438 360.592 350.727 359.076 351.11C361.8 355.537 364.452 359.845 367.18 364.278C365.69 364.692 364.373 365.058 362.65 365.536C366.098 370.451 369.412 375.173 373.042 380.346H351.326V397.429H344.257V380.469H322.396C326.057 375.25 329.374 370.523 332.869 365.541Z",
    fill: "white",
    stroke: "#754D29",
    strokeWidth: 2.91771,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M277.685 253.698C275.928 253.2 274.614 252.828 273.171 252.419C275.88 248.005 278.507 243.725 281.24 239.272C279.843 238.921 278.689 238.631 277.341 238.292C279.871 233.585 282.35 228.973 284.94 224.154C283.364 223.922 282.062 223.731 280.298 223.472C285.906 215.551 289.162 206.698 292.542 197.368C296.064 206.592 299.135 215.532 304.906 223.468C303.141 223.72 301.798 223.911 300.187 224.14C302.769 228.916 305.243 233.493 307.826 238.272C306.551 238.595 305.407 238.884 303.891 239.267C306.616 243.694 309.267 248.003 311.995 252.435C310.505 252.849 309.188 253.215 307.465 253.694C310.914 258.608 314.227 263.33 317.858 268.503H296.142V285.587H289.072V268.626H267.211C270.872 263.408 274.189 258.68 277.685 253.698Z",
    fill: "white",
    stroke: "#754D29",
    strokeWidth: 2.91771,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M261.687 282.007C260.643 281.712 259.863 281.491 259.006 281.248C260.615 278.627 262.175 276.086 263.797 273.442C262.968 273.233 262.283 273.061 261.482 272.86C262.985 270.065 264.457 267.327 265.994 264.466C265.059 264.328 264.285 264.214 263.238 264.06C266.568 259.357 268.501 254.101 270.508 248.562C272.599 254.038 274.423 259.346 277.849 264.059C276.801 264.208 276.004 264.321 275.047 264.457C276.58 267.293 278.049 270.01 279.583 272.848C278.826 273.04 278.147 273.212 277.247 273.439C278.864 276.068 280.439 278.626 282.059 281.258C281.174 281.503 280.392 281.721 279.369 282.005C281.416 284.923 283.384 287.726 285.539 290.798H272.645V300.941H268.448V290.871H255.468C257.642 287.772 259.611 284.965 261.687 282.007Z",
    fill: "white",
    stroke: "#754D29",
    strokeWidth: 2.91771,
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M180.845 239.09C179.302 238.653 178.148 238.326 176.881 237.967C179.26 234.091 181.567 230.331 183.967 226.421C182.741 226.112 181.727 225.858 180.543 225.56C182.765 221.426 184.942 217.375 187.217 213.143C185.833 212.94 184.689 212.772 183.14 212.544C188.066 205.588 190.925 197.813 193.893 189.619C196.987 197.72 199.684 205.571 204.752 212.541C203.202 212.762 202.022 212.93 200.607 213.132C202.875 217.326 205.047 221.345 207.317 225.543C206.196 225.826 205.192 226.08 203.861 226.417C206.253 230.305 208.582 234.088 210.978 237.981C209.669 238.345 208.512 238.666 207 239.087C210.028 243.402 212.938 247.55 216.127 252.093H197.055V267.096H190.846V252.201H171.646C174.862 247.618 177.775 243.466 180.845 239.09Z",
    fill: "white",
    stroke: "#754D29",
    strokeWidth: 2.91771,
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M158.516 248.328C156.759 247.83 155.445 247.458 154.002 247.049C156.711 242.635 159.338 238.355 162.071 233.902C160.674 233.551 159.52 233.261 158.172 232.922C160.702 228.215 163.181 223.602 165.771 218.784C164.195 218.552 162.893 218.361 161.129 218.102C166.737 210.181 169.993 201.328 173.373 191.998C176.895 201.222 179.967 210.162 185.737 218.098C183.972 218.35 182.629 218.541 181.018 218.77C183.6 223.546 186.074 228.123 188.657 232.902C187.382 233.225 186.238 233.514 184.722 233.897C187.447 238.324 190.098 242.633 192.827 247.065C191.336 247.479 190.019 247.845 188.296 248.324C191.745 253.238 195.059 257.96 198.689 263.133H176.973V280.217H169.903V263.256H148.042C151.703 258.037 155.02 253.31 158.516 248.328Z",
    fill: "white",
    stroke: "#754D29",
    strokeWidth: 2.91771,
    strokeMiterlimit: 10
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesktopSm);
export default __webpack_public_path__ + "static/media/desktop-sm.528602c4ce39954f9e9e3c84dff1e1da.svg";
export { ForwardRef as ReactComponent };